var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStop = function SvgStop(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 24 24"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "stop_svg__a",
    width: 24,
    height: 24,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#stop_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6 16V8q0-.824.588-1.412A1.93 1.93 0 0 1 8 6h8q.824 0 1.413.588Q18 7.175 18 8v8q0 .824-.587 1.413A1.93 1.93 0 0 1 16 18H8q-.824 0-1.412-.587A1.93 1.93 0 0 1 6 16m2 0h8V8H8z"
  }))));
};
export default SvgStop;